import type { ConnectorAdapter, ConnectorCatalogEntry, ConnectorId } from './types.js';

export const CONNECTOR_CATALOG: ConnectorCatalogEntry[] = [
  {
    id: 'payvox',
    nameKey: 'connectors.payvox.name',
    descriptionKey: 'connectors.payvox.description',
    available: true
  }
];

const adapters = new Map<ConnectorId, ConnectorAdapter>();

export function registerConnector(adapter: ConnectorAdapter): void {
  adapters.set(adapter.id, adapter);
}

export function getConnector(id: ConnectorId): ConnectorAdapter {
  const a = adapters.get(id);
  if (!a) throw new Error(`Connector not registered: ${id}`);
  return a;
}

export function listCatalog(): ConnectorCatalogEntry[] {
  return CONNECTOR_CATALOG.filter((c) => c.available);
}
